import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroupWrapperComponent } from './form-group-wrapper.component';


@NgModule({
    declarations: [FormGroupWrapperComponent],
    imports: [CommonModule],
    exports: [FormGroupWrapperComponent],
})
export class FormGroupWrapperModule {
}
